import React from 'react';

const IITKorea: React.FC = () => {
  return (
    <div className="text-justify py-4">
      
      <p className="mb-4">
        Pada 2-3 November 2024, ajang <b>Innovative Technology Challenge</b> diadakan di Chonnam National University, Yeosu-si, Korea Selatan. Dalam kompetisi tingkat internasional ini, perwakilan Indonesia berhasil menunjukkan prestasi luar biasa, khususnya di kategori <b>Coding Level Junior</b> dan <b>Innovative Technology Challenge Level Junior</b>.
      </p>

      <h2 className="text-2xl font-bold mb-4 mt-8">Perjalanan Tim Coding Junior</h2>
      <p className="mb-4">
        Peserta dari Indonesia di kategori Coding Level Junior menunjukkan kemampuan luar biasa dengan memecahkan tantangan logika dan pemrograman. Kompetisi ini menguji keterampilan dalam bahasa pemrograman Python untuk menyelesaikan berbagai problem statement yang melibatkan:
      </p>
      
      <ol className="list-decimal pl-6 mb-6 space-y-3">
        <li>
          <p><strong>Pemrograman Dasar</strong>: Logika sederhana untuk menyelesaikan teka-teki algoritma.</p>
        </li>
        <li>
          <p><strong>Problem-Solving</strong>: Studi kasus yang membutuhkan kreativitas dan kecepatan berpikir.</p>
        </li>
        <li>
          <p><strong>Kolaborasi</strong>: Tantangan kelompok yang mengharuskan peserta bekerja sama untuk menemukan solusi.</p>
        </li>
      </ol>
      
      <p className="mb-6">
        Meski kompetisi diikuti oleh peserta dari berbagai negara, tim Coding Junior Indonesia mampu bersaing dengan percaya diri. Semangat dan dedikasi mereka terlihat dari usaha keras selama persiapan hingga pelaksanaan.
      </p>

      <h2 className="text-2xl font-bold mb-4 mt-8">Prestasi di Innovative Technology Challenge Level Junior</h2>
      <ul className="list-disc pl-6 mb-6 space-y-3">
        <li><strong>Prototipe Teknologi</strong>: Ide inovatif yang mampu menyelesaikan masalah dunia nyata.</li>
        <li><strong>Presentasi Kreatif</strong>: Menjelaskan konsep teknologi secara efektif kepada juri.</li>
        <li><strong>Implementasi Teknologi</strong>: Memanfaatkan alat sederhana yang fungsional untuk membangun solusi.</li>
      </ul>
      
      <div>
        <h2 className="text-2xl font-bold mb-4 mt-8">Karya Juara 3: Smart Waste Sorting System</h2>
        <p>
          Prototipe yang dikembangkan adalah <b>&quot;Smart Waste Sorting System&quot;</b>, sistem pemilahan sampah cerdas berbasis sensor untuk meningkatkan kesadaran pengelolaan sampah di sekolah. Dengan sensor jarak dan warna, prototipe ini membantu mendeteksi jenis sampah organik, plastik, dan kertas secara otomatis.
        </p>
      </div>

      <h2 className="text-2xl font-bold mb-4 mt-8">Pengalaman Tak Terlupakan</h2>
      <p className="mb-4">
        Selain kompetisi, peserta juga mendapatkan pengalaman luar biasa selama berada di Korea Selatan:
      </p>
      <ul className="list-disc pl-6 mb-6 space-y-3">
        <li>
          <strong>Kunjungan Kampus Chonnam National University</strong>: Peserta berkesempatan menjelajahi fasilitas kampus dan mengenal budaya akademik di Korea Selatan.
        </li>
        <li>
          <strong>Networking dengan Peserta Internasional</strong>: Mereka berbagi ide dan belajar dari inovasi peserta dari negara lain.
        </li>
        <li>
          <strong>Eksplorasi Budaya Lokal</strong>: Peserta menikmati suasana kota Yeosu-si, mulai dari mencicipi kuliner khas hingga mengunjungi destinasi wisata lokal.
        </li>
      </ul>

      <h2 className="text-2xl font-bold mb-4 mt-8">Harapan dan Kebanggaan</h2>
      <p className="mb-6">
        Keikutsertaan Indonesia dalam ajang internasional ini membuktikan bahwa generasi muda Indonesia memiliki potensi besar di bidang teknologi dan inovasi. Prestasi yang diraih bukan hanya milik individu, tetapi juga menjadi kebanggaan bangsa.
      </p>

      <h2 className="text-2xl font-bold mb-4 mt-8">Dukungan untuk Generasi Inovator</h2>
      <p className="mb-4">
        Semoga pengalaman ini memotivasi lebih banyak siswa Indonesia untuk terus mengasah keterampilan dan berani bersaing di tingkat global. Untuk informasi lebih lanjut tentang program dan kompetisi lainnya, kunjungi:
      </p>
      <p className="mb-6">
        <a href="https://iitchallenge.com/iit-program" className="underline font-semibold text-blue-600 hover:text-blue-800 transition-colors">iitchallenge.com/iit-program</a>
      </p>
      <p className="font-bold">
        Mari dukung langkah generasi muda Indonesia menuju masa depan yang lebih cerah melalui teknologi dan inovasi!
      </p>
    </div>
  );
};

export default IITKorea;